import axios from "axios";

axios.defaults.withCredentials = true;

// You can use your own logic to set your local or production domain
const baseDomain = process.env.LASHIC_API_ENDPOINT;

const baseURL = `https://${baseDomain}`;

export default axios.create({
  baseURL,
  // headers: {
  //   Authorization: "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJsYXNoaWMiLCJleHAiOjE2MjAyODgwMzksInVzZXJfaWQiOiI0NTYifQ.odmg-Y1maPouDPru6dgCKPPuGGRjSXObgWBDTIKts44",
  //   "Ocp-Apim-Subscription-Key": process.env.SUBSCRIPTION_KEY,
  // },
});



// WEBPACK FOOTER //
// ./src/repositories/RepositoryLashic.js